var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1390_9",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.316406,
    width: 34,
    height: 34,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1390_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7233 8.93225H5.27667C4.70944 8.93225 4.25 8.47282 4.25 7.90558C4.25 7.33834 4.70944 6.87891 5.27667 6.87891H28.7233C29.2906 6.87891 29.75 7.33834 29.75 7.90558C29.75 8.47282 29.2906 8.93225 28.7233 8.93225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7233 18.3418H5.27667C4.70944 18.3418 4.25 17.8823 4.25 17.3151C4.25 16.7478 4.70944 16.2884 5.27667 16.2884H28.7233C29.2906 16.2884 29.75 16.7478 29.75 17.3151C29.75 17.8823 29.2906 18.3418 28.7233 18.3418Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7233 27.7543H5.27667C4.70944 27.7543 4.25 27.2948 4.25 26.7276C4.25 26.1604 4.70944 25.7009 5.27667 25.7009H28.7233C29.2906 25.7009 29.75 26.1604 29.75 26.7276C29.75 27.2948 29.2906 27.7543 28.7233 27.7543Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon_menu.0e3f716c7f0832f7579dd32109e33f7e.svg";
export { ForwardRef as ReactComponent };